licenses-notices-1 = BestCraft is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option) any later version.
licenses-notices-2 = BestCraft is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more details.
licenses-notices-3 = You should have received a copy of the GNU Affero General Public License along with BestCraft. If not, see https://www.gnu.org/licenses/.
copyright-notices =
    Copyright 2026 Tnze. All Rights Reserved.
    Referenced FFXIV related resources: Copyright © 2010 - 2026 SQUARE ENIX CO., LTD.

level = Lv
recipe-level = Recipe Lv
class-job-level = Class Job Lv
craftsmanship = 作業精度
control = 加工精度
craft-point = CP
progress = 工数
quality = 品質
durability = 耐久
steps = TURN
condition = 状態
difficulty = 必要工数
initial-quality = 初期品質
conditions = 製作状態フラグ
progress-divider = 作業難度係数
progress-modifier = 作業進捗修正値
quality-divider = 加工難度係数
quality-modifier = 加工品質修正値
difficulty-factor = 製作難度係数
quality-factor = 品質係数
durability-factor = 耐久係数
material-quality-factor = 中間素材品質寄与度

meals = 調理品
medicines = 薬品

name = 名前
amount = 数

specialist = マイスター

carpenter = 木工師
blacksmith = 鍛冶師
armorer = 甲冑師
goldsmith = 彫金師
leatherworker = 革細工師
weaver = 裁縫師
alchemist = 錬金術師
culinarian = 調理師

default = デフォルト
common = 一般的な
custom = カスタム { $id }

basic-synthesis = 作業
basic-touch = 加工
masters-mend = マスターズメンド
hasty-touch = ヘイスティタッチ
rapid-synthesis = 突貫作業
observe = 経過観察
tricks-of-the-trade = 秘訣
waste-not = 倹約
veneration = ヴェネレーション
standard-touch = 中級加工
great-strides = グレートストライド
innovation = イノベーション
final-appraisal = 最終確認
waste-not-ii = 長期倹約
byregot-s-blessing = ビエルゴの祝福
precise-touch = 集中加工
muscle-memory = 確信
careful-synthesis = 模範作業
manipulation = マニピュレーション
prudent-touch = 倹約加工
reflect = 真価
preparatory-touch = 下地加工
groundwork = 下地作業
delicate-synthesis = 精密作業
intensive-synthesis = 集中作業
trained-eye = 匠の早業
advanced-touch = 上級加工
prudent-synthesis = 倹約作業
trained-finesse = 匠の神業
careful-observation = 設計変更
heart-and-soul = 一心不乱
refined-touch = 洗練加工
daring-touch = デアリングタッチ
immaculate-mend = パーフェクトメンド
quick-innovation = クイックイノベーション
trained-perfection = 匠の絶技
stellar-steady-hand = コスモステディハンド

desc-basic-synthesis = 作業を進める。効率：100（Lv31で120に上昇）
desc-basic-touch = 品質を上げる。効率：100
desc-masters-mend = 耐久を30回復する。
desc-hasty-touch = 品質を上げる。効率：100、CPを消費しない、成功率：60%
desc-rapid-synthesis = 作業を進める。効率：250（Lv63で500に上昇）、成功率：50%
desc-observe = 1ターン様子を見る。集中作業・集中加工のコンボに使用する。
desc-tricks-of-the-trade = CPを20回復する。「高品質」以上の状態でのみ使用可能。
desc-waste-not = 耐久の消費を半減する。4ターン継続。
desc-veneration = 作業を進めるアクションの効率が50%上昇する。4ターン継続。
desc-standard-touch = 品質を上げる。効率：125、加工とのコンボでCP消費を抑えられる。
desc-great-strides = 次に使用する加工系アクションの効果が2倍になる。3ターン継続。
desc-innovation = 品質を上げるアクションの効率が50%上昇する。4ターン継続。
desc-final-appraisal = 作業を進めるアクション実行時、完成直前に一度だけ止める。5ターン継続。
desc-waste-not-ii = 耐久の消費を半減する。8ターン継続。
desc-byregot-s-blessing = インナークワイエットのスタック数を消費して品質を上げる。効率100～300。スタック1につき効率+20。
desc-precise-touch = 品質を上げる。効率：150、インナークワイエットが2スタック付与される。「高品質」以上の状態でのみ使用可能。
desc-muscle-memory = 最初のターンでのみ使用可能。作業を進める。効率：300。次の作業系アクションの効果が2倍になる。5ターン継続。
desc-careful-synthesis = 作業を進める。効率：150（Lv82で180に上昇）。
desc-manipulation = ターン終了時に耐久が5回復する。8ターン継続。
desc-prudent-touch = 品質を上げる。効率：100、耐久消費が5になる。倹約状態では使用不可。
desc-reflect = 最初のターンでのみ使用可能。品質を上げる。効率：300、インナークワイエットが2スタック付与される。
desc-preparatory-touch = 品質を上げる。効率：200、インナークワイエットが2スタック付与される。耐久を20消費する。
desc-groundwork = 作業を進める。効率：300（Lv86で360に上昇）。耐久を20消費する。耐久不足時は効率半減。
desc-delicate-synthesis = 作業を進めつつ品質を上げる。効率：100（Lv94で作業効率150に上昇）。
desc-intensive-synthesis = 作業を進める。効率：400。「高品質」以上の状態でのみ使用可能。
desc-trained-eye = 最初のターンで、かつレシピレベルが自身のレベルより10以上低い場合のみ使用可能。最大品質の100%を上昇させる。
desc-advanced-touch = 品質を上げる。効率：150、中級加工とのコンボでCP消費を抑えられる。
desc-prudent-synthesis = 作業を進める。効率：180、耐久消費が5になる。倹約状態では使用不可。
desc-trained-finesse = インナークワイエットのスタック数が10のときのみ使用可能。品質を上げる。効率：100、耐久を消費しない。
desc-careful-observation = 能工巧匠の設計図を1つ消費し、状態を変更する。1回の製作につき最大3回使用可能。現在シミュレーターUIは状態切替に対応していません。
desc-heart-and-soul = 能工巧匠の設計図を1つ消費し、集中加工・集中作業・秘訣のいずれかを1回使用可能にする。1回の製作につき最大1回使用可能。

desc-refined-touch = 品質を上げる。効率：100、加工とのコンボでインナークワイエットが追加で1スタック付与される。
desc-daring-touch = 品質を上げる。効率：150、CPを消費しない、成功率：60%
desc-immaculate-mend = 耐久を全回復する。
desc-quick-innovation = イノベーション状態を付与する。1ターン継続。1回の製作につき1回まで使用可能。
desc-trained-perfection = 一度だけ、アクションによる耐久の消費が0になる。一回の製作につき1回まで使用可能。

desc-stellar-steady-hand = 次に使用するアクションが必ず成功する。3ターン継続。

normal = 通常
good = 高品質
excellent = 最高品質
poor = 低品質
centered = 安定
sturdy = 頑丈
pliant = 高能率
malleable = 高進捗
primed = 長持続
goodomen = 良兆候
robust = 頑固

# アクション実行エラー
DurabilityNotEnough = 耐久が不足しています
CraftPointNotEnough = CPが不足しています
CraftingAlreadyFinished = 製作が完了しているためアクションを実行できません
PlayerLevelTooLow = このアクションはまだ習得していません。プレイヤーレベルが不足しています
RequireGoodOrExcellent = このアクションは「高品質」以上の状態でのみ使用可能です
NotAllowedInWastNotBuff = このアクションは倹約・長期倹約状態では使用できません
OnlyAllowedInFirstStep = このアクションは最初のターンでのみ使用可能です
LevelGapMustGreaterThanTen = このアクションは最初のターンで、かつレシピレベルが自身のレベルより10以上低い場合のみ使用可能です
RequireInnerQuiet1 = このアクションはインナークワイエットのスタック数が1以上のときのみ使用可能です
RequireInnerQuiet10 = このアクションはインナークワイエットのスタック数が10のときのみ使用可能です
CarefulObservationUsed3 = 設計変更は最大3回まで使用可能です
HeartAndSoulUsed = 一心不乱は1回の製作につき1回のみ使用可能です
FocusNeverFailsAfterObserved = 経過観察後の集中アクションは失敗しません
RequireHastyTouchSuccessed = ヘイスティタッチ成功後に使用可能です
QuickInnovationUsed = クイックイノベーションは1回の製作につき1回のみ使用可能です
NotAllowedInInnovationBuff = イノベーション状態ではクイックイノベーションを使用できません
TrainedPerfectionUsed = 匠の絶技は1回の製作につき1回のみ使用可能です

# アップデーター
update-available = 利用可能なアップデート: v{ $version }
update-now = 今すぐ更新
update-not-now = 今じゃない
update-installing = 更新中です。しばらくお待ちください。
update-ask-relaunch = アップデートがインストールされています。アプリケーションを再起動しますか？

update-pending = 更新中
update-error = 更新に失敗しました: { $error }
update-done = 更新完了
update-uptodate = すでに最新バージョン

update-started = アップデートダウンロード開始
update-progress = 更新ダウンロード中：{ $progress }
update-done = 更新ダウンロード終了

# Rust Errors
player-level-lower-than-recipe-requirement = プレイヤーレベルが選択したレシピの最低要件を満たしていません
unknown-recipe-level = データベースに存在しないレシピレベルです
solver-already-exist = ソルバーは既に存在します
solver-is-creating = ソルバーは作成中です
solver-doesn-t-exist = ソルバーが存在しません
solver-isn-t-prepared = ソルバーの準備が完了していません

# Titles
attributes = 属性
select-recipe = レシピ検索
custom-recipe = カスタムレシピ
bill-of-material = 材料リスト
settings = 設定
